import {
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { spacing } from 'ext-ui/style/spacing'
import { font_family_weight_medium, font_md } from 'ext-ui/style/typography'
import { css } from 'styled-components'

/**
 * Payments page (Bill Pay M3). Deliberately mirrors VendorsPage.style so the
 * two Bill Pay surfaces read as one section: header row with the title, then a
 * bordered Box that fills the remaining page height and holds the (for now)
 * empty state.
 *
 * The prototype's populated table, toolbar and Pay Bill CTA are NOT here yet —
 * the payments API does not exist and the polished table was explicitly scoped
 * out of this week (sprint turnover 2026-08-04). This is the page shell those
 * pieces land in. Tokens only.
 */
export default css`
  display: flex;
  flex-direction: column;
  gap: ${spacing(5)};
  flex: 1;
  min-height: 0;

  .payments-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    align-self: stretch;
  }

  .payments-title {
    font-size: 32px;
    line-height: 36px;
    font-family: ${font_family_weight_medium};
    color: ${text_colorTextPrimary};
    margin: 0;
  }

  /* Same flex-1 container chain as the Vendors card: the bordered Box fills
     the remaining page height rather than shrink-wrapping its contents. Box is
     a plain div with no built-in stretch, so the page establishes it here. */
  .payments-box {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    width: 100%;
  }

  .payments-empty {
    display: flex;
    flex: 1;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${spacing(3)};
    padding: ${spacing(12)} ${spacing(6)};
    text-align: center;
  }

  .payments-empty-title {
    font-size: 20px;
    line-height: 24px;
    font-family: ${font_family_weight_medium};
    color: ${text_colorTextPrimary};
    margin: 0;
  }

  .payments-empty-description {
    ${font_md};
    color: ${text_colorTextSecondary};
    max-width: 440px;
    margin: 0;
  }
`
